(() => {
  // app/scripts/common/model/product-card.js
  var ProductCard = class extends HTMLElement {
    constructor() {
      super();
      this.elms = {
        form: this.querySelector("form"),
        atcButton: this.querySelector(".js-atc-btn"),
        atcButtonMobile: this.querySelector(".js-atc-btn-mobile"),
        quickViewButton: this.querySelector(".js-product-card-quick-view"),
        wishlistButtons: this.querySelectorAll(".js-wl")
      };
      this.initATC();
      this.initATWL();
      this.initQuickView();
    }
    initATC() {
      const { form, atcButton } = this.elms;
      if (!form || !atcButton)
        return;
      form.addEvent("submit", (e) => {
        if (window.theme.pageType == "cart")
          return;
        e.preventDefault();
        const submitter = e.submitter;
        if (submitter.getAttribute("aria-disabled") === "true")
          return;
        submitter.setAttribute("aria-disabled", true);
        if (!submitter.querySelector(".svg-loading")) {
          submitter.insertAdjacentHTML("beforeend", '<svg class="svg-loading" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; shape-rendering: auto;" width="28px" height="28px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><circle cx="50" cy="50" fill="none" stroke="currentColor" stroke-width="5" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">  <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform></circle></svg>');
        }
        submitter.addClass("has-pending");
        window.Cart.add(form).catch((error) => {
          AT.loadPopupMessage().then(() => {
            window.Popups.closeAll();
            window.PopupMessage.open(error.description || error.message);
          });
        }).finally(() => {
          submitter.removeClass("has-pending");
          submitter.removeAttribute("aria-disabled");
        });
      });
    }
    initATWL() {
      const { wishlistButtons } = this.elms;
      if (!wishlistButtons.length)
        return;
      wishlistButtons.forEach((wishlistButton) => {
        const { productTitle, productHandle, productImage, productImageRatio, productImagePadding } = wishlistButton.dataset;
        const product = {
          title: productTitle,
          handle: productHandle,
          image: productImage,
          imageRatio: productImageRatio,
          imagePadding: productImagePadding
        };
        if (window.Wishlist.wishlist.includes(product.handle)) {
          wishlistButton.classList.add("is-added");
          wishlistButton.setAttribute("aria-label", wishlistButton.getAttribute("data-remove-from-wishlist"));
          wishlistButton.setAttribute("title", wishlistButton.getAttribute("data-remove-from-wishlist"));
        } else {
          wishlistButton.setAttribute("aria-label", wishlistButton.getAttribute("data-add-to-wishlist"));
          wishlistButton.setAttribute("title", wishlistButton.getAttribute("data-add-to-wishlist"));
        }
        wishlistButton.addEventListener("click", (e) => {
          const target = e.target;
          if (target.classList.contains("is-added")) {
            window.Wishlist.remove(product);
            window.Wishlist.showPopup(product, false);
          } else {
            window.Wishlist.add(product);
            window.Wishlist.showPopup(product);
          }
          document.querySelectorAll(`button.js-wl[data-product-handle="${product.handle}"]`).forEach((button) => {
            button.classList.toggle("is-added");
            if (button.classList.contains("is-added")) {
              button.setAttribute("aria-label", button.getAttribute("data-remove-from-wishlist"));
            } else {
              button.setAttribute("aria-label", button.getAttribute("data-add-to-wishlist"));
            }
          });
        });
      });
    }
    initQuickView() {
      let { quickViewButton } = this.elms;
      if (!quickViewButton)
        return;
      quickViewButton.addEvent("click", function() {
        let { productHandle } = this.dataset;
        if (this.getAttribute("aria-disabled") === "true")
          return;
        this.setAttribute("aria-disabled", true);
        if (!this.querySelector(".svg-loading")) {
          this.insertAdjacentHTML("beforeend", '<svg class="svg-loading" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; shape-rendering: auto;" width="28px" height="28px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><circle cx="50" cy="50" fill="none" stroke="currentColor" stroke-width="5" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">  <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform></circle></svg>');
        }
        this.addClass("has-pending");
        let arrPromise = [];
        arrPromise.push(AT.loadPopupQuickView());
        arrPromise.push(AT.productsViewedQuickly[productHandle] ? AT.productsViewedQuickly[productHandle] : fetch(`${window.Shopify.routes.root}products/${productHandle}?view=quick-view`, { dataType: "text" }));
        Promise.all(arrPromise).then((res) => {
          if (res[0]) {
            window.Popups.closeAll();
            PopupQuickView.open(res[1]);
            AT.productsViewedQuickly[productHandle] = res[1];
          } else {
            console.log("An error occurred while loading quick view");
          }
        }).finally(() => {
          this.removeClass("has-pending");
          this.removeAttribute("aria-disabled");
        });
      });
    }
  };

  // app/scripts/product-card.js
  customElements.define("product-card", ProductCard);
})();
